import React from 'react';
import { CartesianGrid, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, Legend, YAxis } from "recharts";
import moment from "moment";
import Colours from '@shared/ui/atoms/Colours';
import styled from "styled-components";
import { CustomToolTip } from "./CustomToolTip";

export function OfficeConfirmationLineChart(props: Props) {
  const {reportData, selectedDate, onSelectDate} = props;
  return (
    <ReportingContainer style={{height: 400}}>

      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={400}
          data={reportData}
          margin={{top: 10, right: 30, left: 0, bottom: 0}}
          onClick={(state: any) => state?.activeLabel && onSelectDate?.(state.activeLabel)}
          style={{cursor: onSelectDate ? 'pointer' : undefined}}
        >
          <CartesianGrid stroke={Colours.mildGrey} strokeDasharray="5 5"/>
          <XAxis dataKey="date" tickFormatter={(date: string) => moment(date).format('ddd')[0]} fontFamily={'proxima-nova'} fill={Colours.mildGrey} fontSize={18} axisLine={false} />
          <YAxis fontFamily={'proxima-nova'} fill={Colours.mildGrey} fontSize={18} axisLine={false} />
          <Tooltip content={<CustomToolTip />} />
          {selectedDate && <ReferenceLine x={selectedDate} stroke={Colours.darkGrey} strokeDasharray="3 3" />}
          <Line type="monotone" dataKey="officeBookings" name="Office bookings" stroke={Colours.blue} />
          <Line type="monotone" dataKey="confirmations" name="Confirmed" stroke={Colours.green} />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </ReportingContainer>
  )
}

interface Props {
  // One item per day, with date as YYYY-MM-DD
  reportData: any[];
  selectedDate?: string;
  onSelectDate?: (date: string) => void;
}

const ReportingContainer = styled.div`
  .recharts-tooltip-wrapper {
    .customTooltip {
      color: red !important;
    }
  }
`
